<div class="language-warning tw:bg-red-lightest tw:border tw:border-solid tw:border-red">
  <h3 class="tw:flex tw:flex-row! tw:items-center tw:gap-4 tw:mb-0">
    <vee-icon icon="error" class="tw:text-[2rem]"></vee-icon
    ><span>{{ "KEYS.ATTENTION" | translate }}</span>
  </h3>

  @if (type == 'only_german') {
    <p class="tw:text-base">
      {{ "COMPONENTS.TRANSLATION_WARNING.PAGE" | translate }}
    </p>
  } @else if (type == 'result') {
    <p class="tw:text-base">
      {{ 'COMPONENTS.TRANSLATION_WARNING.RESULT' | translate }}
    </p>
  } @else if (type == 'action') {
    <p class="tw:text-base">
      {{ 'COMPONENTS.TRANSLATION_WARNING.ACTION' | translate }}
    </p>
  }
</div>
